import { FC, useCallback } from 'react';
import { Image } from '~/components/image';
import { QRCODE_MAP } from './assets';
import { useAtomValue } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { useTranslation } from 'react-i18next';
import { EPageType } from 'shared/models';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ClickPosition } from '~/utils/click-position';
import { ModuleType } from '~/utils/module-type';

import './style.scss';

export const PCReflow: FC = () => {
  const { pageType } = useAtomValue($PageLevelTraffic);
  const { t } = useTranslation();

  const DESCRIPTION_KEY_MAP: { [key in EPageType]: string } = {
    [EPageType.feed]: t('seo_scanCode_desc_postDetail'),
    [EPageType.article]: t('seo_scanCode_desc_postDetail'),
    [EPageType.video]: t('seo_scanCode_desc_postDetail'),
    [EPageType.discover]: t('seo_scanCode_desc_keyword'),
    [EPageType.poi]: t('seo_scanCode_desc_poi'),
    [EPageType.hashtag]: t('seo_scanCode_desc_hashtag'),
    [EPageType.user]: t('seo_scanCode_desc_profile'),
    [EPageType.user_follow]: t('seo_scanCode_desc_profile'),
    [EPageType.user_topic]: t('seo_scanCode_desc_profile'),
    [EPageType.search_sug]: t('seo_scanCode_desc_search'),
    [EPageType.experience]: t('seo_scanCode_desc_search'),
    [EPageType.experience_article]: t('seo_scanCode_desc_search'),
  };

  const title = t('seo_scanCode_title');
  const description = DESCRIPTION_KEY_MAP[pageType];
  const src = QRCODE_MAP[pageType];

  const observedRef = useViewTracking({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        current_position: ClickPosition.scan_code,
        current_page_module: ModuleType.scan_code,
      });
    }, []),
  });

  return (
    <div className="pc-reflow" ref={observedRef}>
      <span className="title">{title}</span>
      <p className="description">{description}</p>
      <div className="qrcode">
        <Image src={src} alt={title} />
      </div>
    </div>
  );
};
